// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"1167":"01d2aefe0f3c9201","2741":"5d00547630d77edf","2937":"8549aaeb3e4e6c78","5279":"dcb0c7c8332a7f56","7229":"ef905d2196dd9daa","9651":"2553c98214e9cd01"}[chunkId] + ".js";
};